import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectGreenroomSessionMeetings } from '@/store/slices/project/selectors';
import { Speaker } from '@/types/speakers.types';

const useGetSpeakerRole = ({
  speaker,
  sessionUuid,
}: {
  speaker?: Speaker | null;
  sessionUuid?: string;
}): 'Presenter' | 'Speaker' | 'Viewer' => {
  const meetings = useAppSelector(selectGreenroomSessionMeetings);

  return useMemo(() => {
    const sessionMeetingData = meetings?.[sessionUuid || ''];
    const matchedInvite = sessionMeetingData?.invites?.find(
      (invitee) => invitee.profile?.events_profile === speaker?.bl_admin?.id
    );

    const isMeetingPresenter = matchedInvite && !matchedInvite?.watcher_only;
    const isViewer = matchedInvite && !!matchedInvite?.watcher_only;

    // if watcher only, they're a "viewer"
    if (isViewer) return 'Viewer';
    // if presenter role and not watcher only (aka, meeting presenter)
    if (isMeetingPresenter) return 'Presenter';
    // else they're just regular old speaker
    return 'Speaker';
  }, [meetings, sessionUuid, speaker]);
};

export default useGetSpeakerRole;
